import {FC, useCallback} from 'react'
import {useAppDispatch} from 'redux/config'
import {useSelector} from 'react-redux'
import {
  select_jobRequestsHistory,
  select_gridSession_pageCount,
  select_gridSession_pageSizeOptions,
  select_showDetails,
  select_status,
}
  from 'redux/jobRequests/selectors'
import {EmptyStateProps} from 'src/components/EmptyState/index'
import React from 'react'
import {DataGrid} from '@mdsol/onex-design/DataGrid'
import columnsConfig from './columnsConfig'
import {Status} from 'commonTypes'
import {handleGridChange} from '../../../../redux/jobRequests/jobRequests.duck'
import GridControl from './GridControl'
import 'components/common/grid/grid.scss'
import JobRequestDetailsPanel from 'components/view/jobRequests/jobRequestsHistory/JobRequestDetails'
import {select_router_params} from 'redux/router/selectors'

const emptyStateOptions = {
  title: 'No data',
  subtitle: 'No job status requests available',
  defaultImgVariant: 'noData',
} as EmptyStateProps

const JobRequest: FC = () => {
  const dispatch = useAppDispatch()

  const {totalCount, jobStatusRequests} = useSelector(select_jobRequestsHistory)
  const pageCount = useSelector(select_gridSession_pageCount)
  const pageSizeOptions = useSelector(select_gridSession_pageSizeOptions)
  const status = useSelector(select_status)
  const displayRowDetails = useSelector(select_showDetails)
  const {sorting, pageSize, pageIndex} = useSelector(select_router_params)
  const isNavigating = !sorting // any missing routing params mean router started a transition to another state

  const handleChangeControl = useCallback((updatedState)=> {
    dispatch(handleGridChange({pagination: updatedState.pagination}))
  }, [dispatch])

  const onSortingChange = useCallback((updatedSorting) => {
    dispatch(handleGridChange({sorting: updatedSorting}))
  }, [dispatch])

  return (
    !isNavigating ?
      <div id='grid-container' className={`${displayRowDetails ? 'with-row-details' : ''}`}>
        <div className='main-content'>
          <DataGrid
            dataTestId='data-load-requests-data-grid'
            isLoading={status === Status.PENDING}
            enablePagination
            pagination={{pageSize, pageIndex}}
            state={{sorting: [sorting]}}
            onSortingChange={onSortingChange}
            columns={columnsConfig}
            data={jobStatusRequests}
            rowsPerPageOptions={[...pageSizeOptions]}
            pageCount={pageCount}
            onChangeControl={handleChangeControl}
            manualDataLength={totalCount}
            manualSorting={true}
            enableSorting
            emptyStateOptions={emptyStateOptions}
            customGridControl={<GridControl key='key-event-messaging-grid-control' />}
          />
        </div>
        {displayRowDetails && (
          <div className='details-panel'>
            <JobRequestDetailsPanel />
          </div>
        )}
      </div> : null
  )
}

export default JobRequest
